'use strict'

const PropTypes = require('prop-types')
const types = require('../../types')
const React = require('react')

const GenericInput = require('../inputs/generic')
const GenericForm = require('../forms/generic')
const Textarea = require('../inputs/textarea')
const EmailInput = require('../inputs/email')
const Captcha = require('../../components/captcha/captcha')
const styles = require('./contact.css')

class CommonSupportFormContainer extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      disableSubmitButton: this.props.showCaptcha,
    }
  }

  setSubmitButtonDisable = buttonState => {
    if (this.state.disableSubmitButton !== buttonState) {
      this.setState({disableSubmitButton: buttonState})
    }
  }

  submitButtonState = () => {
    return !this.props.enableSubmit(this.props.formData) || this.state.disableSubmitButton
  }

  render() {
    const {formData, onSubmit, disableUsernameField, showCaptcha} = this.props

    return (
      <GenericForm
        formId="contact"
        action="/support"
        formData={formData}
        disabled={this.submitButtonState()}
        onSubmit={onSubmit}
        className="w-100 mt3 pt0 "
      >
        <input type="hidden" name="inquire" value={formData.contact.inquire && formData.contact.inquire.value} />
        <input
          type="hidden"
          name="security-inquire"
          value={formData.contact['security-inquire'] && formData.contact['security-inquire'].value}
        />
        <input
          type="hidden"
          name="account-inquire"
          value={formData.contact['account-inquire'] && formData.contact['account-inquire'].value}
        />
        <p>Asterisk (*) Indicates Required Field </p>
        <GenericInput name="name" disabled={disableUsernameField} label="Name *" formData={formData} className="mb2" />
        <EmailInput name="email" disabled={disableUsernameField} label="Email *" formData={formData} className="mb2" />
        <GenericInput name="subject" label="Subject *" formData={formData} className="mb2" required />
        {this.props.children}
        <Textarea
          name="message"
          label="How can we help? *"
          placeholder="Please describe exactly what you're trying to accomplish."
          formData={formData}
          required
        />
        {showCaptcha && (
          <Captcha formId="contact" formData={formData} setSubmitButtonDisable={this.setSubmitButtonDisable} />
        )}
        <div className={styles.spacer} />
      </GenericForm>
    )
  }
}

CommonSupportFormContainer.propTypes = {
  formData: types.formData.isRequired,
  enableSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  disableUsernameField: PropTypes.bool,
  children: PropTypes.node,
}

module.exports = CommonSupportFormContainer
